window.documentDownloadFormatter = function(value, row) {
    let html = '';
    if (row.action_download) {
        html += '<a href="'+row.action_download+'" class="btn btn-default btn-sm button-document-download" data-disable-nprogress="true">';
        html += '<i class="fa fa-download me-2"></i>';
        html += __('Download');
        html += '</a>';
    }
    return html;
};
